module.exports = __webpack_public_path__ + "static/logistics-planning@2x-2b0a6ba26e7fb4c8e854aa7f6bf8e71f.png";